import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

interface IContainerProps {
  isShowing: boolean;
}

export const Container = styled.button<IContainerProps>`
  width: 45px;
  height: 45px;
  box-shadow: 1px 1px 1px 1px #d8d8d8;

  display: ${({ isShowing }) => isShowing ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;

  background: ${customTheme.colors.white};
  border-radius: 100%;
  border: none;
  font-weight: bold;
  font-size: 32px;
  line-height: 37px;
  text-align: center;
  color: ${({ color }) => color || customTheme.colors.black};
  cursor: pointer;
`
